import { PublicCategoriesApi } from "../../../findifyv2-api-ts/public/categories/CategoriesApi";
import { PublicEventsApi } from "../../../findifyv2-api-ts/public/events/EventsApi";
import { PublicTicketTypesApi } from "../../../findifyv2-api-ts/public/tickets/TicketTypesApi";
import { PublicTicketCollectionsApi } from "../../../findifyv2-api-ts/public/tickets/TicketCollectionsApi";
import { PublicTicketCollectionTicketsApi } from "../../../findifyv2-api-ts/public/tickets/TicketCollectionTicketsApi";
import { PublicTicketSectionsApi } from "../../../findifyv2-api-ts/public/tickets/TicketSectionsApi";
import { PublicTicketSectionsSeatedApi } from "../../../findifyv2-api-ts/public/tickets/TicketSectionsSeatedApi";
import { PublicContentsApi } from "../../../findifyv2-api-ts/public/contents/ContentsApi";
import { PublicPointOfInterestApi } from "../../../findifyv2-api-ts/public/pois/PointOfInterestApi";
import { PublicRoutesApi } from "../../../findifyv2-api-ts/public/routes/RoutesApi";
import { PublicStoreApi } from "../../../findifyv2-api-ts/public/store/StoreApi";
import { PublicShopCartApi } from "../../../findifyv2-api-ts/public/store/ShopCartApi";
import { PublicShopOrdersApi } from "../../../findifyv2-api-ts/public/store/ShopOrdersApi";
import { PublicFormsApi } from "../../../findifyv2-api-ts/public/forms/FormsApi";
import { PublicWorkspacesApi } from "../../../findifyv2-api-ts/public/workspaces/WorkspacesApi";
import { PublicAuthenticationApi } from "../../../findifyv2-api-ts/public/authentication/AuthenticationApi";
import { PublicMenusApi } from "../../../findifyv2-api-ts/public/menus/MenusApi";
import { PublicMenusItemsApi } from "../../../findifyv2-api-ts/public/menus/MenusItemsApi";
import { PublicUserTicketsApi } from "../../../findifyv2-api-ts/public/tickets/UserTicketsApi";
import { PublicCustomerBillingAddressesApi } from "../../../findifyv2-api-ts/public/customer_billing_addresses/CustomerBillingAddressesApi";
import { CountriesApi } from "../../../findifyv2-api-ts/shared/countries/CountriesApi";
import { FindifyDataContextType } from "@/contexts/FindifyDataContext";

export const getApiFromModule: any = (module: string, findifyDataContext: FindifyDataContextType, itemId?: number) => {
    if (!findifyDataContext) return null;
    
    const domain = findifyDataContext.workspace?.primary_domain?.domain_name ?? '';
    const token = findifyDataContext.userCustomerAccounts?.[findifyDataContext?.workspace?.workspace_id]?.access_token;

    switch (module) {
        case 'authentication':
            return new PublicAuthenticationApi(domain, token);
        case 'categories':
            return new PublicCategoriesApi(domain, token);
        case 'contents':
            return new PublicContentsApi(domain, token);
        case 'events':
            return new PublicEventsApi(domain, token);
        case 'forms':
            return new PublicFormsApi(domain, token);
        case 'menus':
            return new PublicMenusApi(domain, token);
        case 'menus_items':
            return new PublicMenusItemsApi(domain, (itemId ?? '').toString());
        case 'points_of_interest':
            return new PublicPointOfInterestApi(domain, token);
        case 'routes':
            return new PublicRoutesApi(domain, token);
        case 'workspaces':
            return new PublicWorkspacesApi(domain, token);
        case 'store':
            return new PublicStoreApi(domain, token);
        case 'tickets_types':
            return new PublicTicketTypesApi(domain, token);
        case 'tickets_collections':
            return new PublicTicketCollectionsApi(domain, token);
        case 'tickets_collections_tickets':
            return new PublicTicketCollectionTicketsApi(domain, (itemId ?? '').toString(), token);
        case 'tickets_sections':
            return new PublicTicketSectionsApi(domain, token);
        case 'tickets_sections_seated':
            return new PublicTicketSectionsSeatedApi(domain, (itemId ?? '').toString(), token);
        case 'shop_cart':
            return new PublicShopCartApi(domain, token);
        case 'shop_order':
            return new PublicShopOrdersApi(domain, token);
        case 'user_tickets':
            return new PublicUserTicketsApi(domain, token);
        case 'customer_billing_addresses':
            return new PublicCustomerBillingAddressesApi(domain, token);
        case 'countries':
            return new CountriesApi();
        default:
            return null;
    }
}
